import { MetadataField } from "@mcleod/core";
import { Textbox } from "./Textbox";
import { DataSourceMode } from "../../databinding/DataSource";
import { ValidationResult } from "../../base/ValidationResult";

/**
 * Shared input constraints validation used by both Textbox input-time checks and TextboxValidator.
 */
export class TextboxInputConstraintsValidator {
    public static validateInputConstraints(value: string, textbox: Textbox, boundField: MetadataField): ValidationResult {
        return TextboxInputConstraintsValidator.validateMaxLength(value, textbox, boundField);
    }

    public static validateMaxLength(value: string, textbox: Textbox, boundField: MetadataField): ValidationResult {
        if (value == null || boundField == null || textbox.hasLookupModel() || textbox.getCurrentDataSourceMode() === DataSourceMode.SEARCH) {
            return { component: textbox, isValid: true };
        } else {
            const exceedsMaxLength = boundField.length != null && value.length > boundField.length;
            const message = exceedsMaxLength ? `You have exceeded the ${boundField.length} character limit.` : undefined;
            return { component: textbox, isValid: !exceedsMaxLength, validationMessage: message };
        }
    }
}
